import { WidthArchiveLabel } from '@app/shared/components';
import type { NClients } from '@app/types';

import type { CheckboxOptionType } from 'antd';

export const getServicesCategoriesOptions = (
  employees: NClients.ModelClientsFilterData['CategoryServices']
): CheckboxOptionType<
  NClients.ModelClientsFilterData['CategoryServices'][number]['Id']
>[] => {
  const sortedEmployees = [...employees].sort((a, b) =>
    a.IsDeleted === b.IsDeleted ? 0 : a.IsDeleted ? 1 : -1
  );

  return sortedEmployees.map(({ Id, Name, IsDeleted }) => {
    return {
      label: <WidthArchiveLabel title={Name} isDeleted={IsDeleted} />,
      value: Id,
      title: Name || '',
    };
  });
};
